import { FlowDropOffAppointmentFragment } from '@portal/schema';

export const name = (fulfiller: FlowDropOffAppointmentFragment['facility']['fulfiller']) =>
  fulfiller.__typename === 'DropOff__ThirdPartySelfStorageFacility' ? fulfiller.operator : 'Clutter Self Storage';
